var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mail"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon/content/mail_24px",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6673 3.99935C14.6673 3.26602 14.0673 2.66602 13.334 2.66602H2.66732C1.93398 2.66602 1.33398 3.26602 1.33398 3.99935V11.9993C1.33398 12.7327 1.93398 13.3327 2.66732 13.3327H13.334C14.0673 13.3327 14.6673 12.7327 14.6673 11.9993V3.99935ZM13.334 3.99935L8.00065 7.32601L2.66732 3.99935H13.334ZM8.00065 8.66602L2.66732 5.33268V11.9993H13.334V5.33268L8.00065 8.66602Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.047fed0bf78005e4aacaef9efc4184a7.svg";
export { ForwardRef as ReactComponent };